import { Component } from 'react';

import { imageFile } from 'common/helpers/miscHelper';

import ProductImageThumbnail from './ProductImageThumbnail';

class ProductDetailImage extends Component {
  constructor(props) {
    super(props);
    const { product, index } = props;
    let firstImage = product.images[0].src || null;
    if (product.images[index]) {
      firstImage = product.images[index].src;
    }

    this.state = {
      imageSrc: firstImage
    };
  }

  handleClick = (src) => {
    this.setState({
      imageSrc: src
    });
  };

  render() {
    const { state, props } = this;
    const { imageSrc } = state;
    const { product, width, noImageTag, size = 'large' } = props;
    const hasMultipleImages = product.images.length > 1;

    const image = imageFile(imageSrc, size);

    if (noImageTag) {
      return image;
    }

    return (
      <>
        <img src={image} alt={product.title} width={width} loading="lazy" />
        {hasMultipleImages && renderThumbnails(product, this.handleClick)}
      </>
    );
  }
}

const renderThumbnails = (product, handleClick) => (
  <div className="c7-product-detail__photo__thumbs">
    {product.images.map((image) => (
      <ProductImageThumbnail
        key={image.id}
        image={image}
        onClick={handleClick}
        alt={product.title}
      />
    ))}
  </div>
);

export default ProductDetailImage;
